export default __webpack_public_path__ + "static/media/Twitter.4104ffa7.svg";